import { ActorAccessRedirect } from './ActorAccessRedirect';

/**
 * Перенаправление на страницу проекта для актера
 */
export const ActorProjectAccessRedirect = () => {
  return <ActorAccessRedirect resourceType='проект' />;
};
